import { MyMillMachineItem } from './MyMillMachineItem';

export interface IMyMillUnitItem {
    uuid: string;
    name: string;
    customerName: string;
    machines: MyMillMachineItem[];
}

export class MyMillUnitItem implements IMyMillUnitItem {
    public uuid: string;
    public name: string;
    public customerName: string;
    public machines: MyMillMachineItem[];

    constructor();
    // tslint:disable-next-line: unified-signatures
    constructor(obj: IMyMillUnitItem);
    constructor(obj?: any) {
        /**
         * for dexi models we need id as primary key so rename this here
         * for api response
         */
        this.uuid = obj && obj.uuid || '';
        this.name = obj && obj.name || '';
        this.customerName = obj && obj.customerName || '';
        this.machines = [];
        if (obj && obj.machines !== undefined) {
            obj.machines.forEach((machine: MyMillMachineItem) => {
                this.machines.push(new MyMillMachineItem(machine));
            });
        }
    }
}
